'use client'

import { format } from 'date-fns'
import { Calendar as CalendarIcon } from 'lucide-react'
import { Dispatch, HTMLAttributes, ReactNode, SetStateAction } from 'react'
import { DateRange } from 'react-day-picker'

import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/utils'

export function DatePickerWithRange({
  className,
  date,
  setDate,
  children,
  footerChildren,
  buttonWidth,
}: HTMLAttributes<HTMLDivElement> & {
  date: DateRange | undefined
  setDate: Dispatch<SetStateAction<DateRange | undefined>>
  children?: ReactNode
  footerChildren?: ReactNode
  buttonWidth?: string
}) {
  return (
    <div className={cn('grid gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={'outline'}
            className={cn(
              buttonWidth
                ? 'justify-start text-left font-normal h-8 truncate p-2 text-sm'
                : 'w-auto justify-start text-left font-normal h-8',
              !date && 'text-muted-foreground'
            )}
            style={buttonWidth ? { width: buttonWidth } : undefined}
          >
            <CalendarIcon className="mr-2 h-5 w-5" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, 'LLL dd, y')} -{' '}
                  {format(date.to, 'LLL dd, y')}
                </>
              ) : (
                format(date.from, 'LLL dd, y')
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <div className="flex flex-row">
            <div className="p-2">{children}</div>
            <div>
              <Calendar
                mode="range"
                defaultMonth={date?.from}
                selected={date}
                onSelect={setDate}
              />
              {footerChildren}
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}
